module.exports = __webpack_public_path__ + "static/media/open_password.9ca227cf.svg";